import { FileExplorer } from "@/components/files";

export default function FilesPage() {
  return <FileExplorer folderId={null} />;
}
